import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import LandingPage from './pages/LandingPage';
import EmailVerification from './pages/EmailVerification'; // 🆕 NEW: Email verification page
import '@fortawesome/fontawesome-free/css/all.min.css';
import toast, { Toaster } from 'react-hot-toast';
import ErrorBoundary from './components/ErrorBoundary';
import SEOHead from './components/SEOHead';
import Tracker from './components/Tracker'; // Enhanced analytics tracker
import { initGTM } from './utils/analytics';
// import AnalyticsDebug from './components/AnalyticsDebug'; // Uncomment for development

// Initialize Google Tag Manager
const GTM_ID = process.env.REACT_APP_GTM_ID; // Add this to your .env file

function App() {
    // Initialize GTM on app start
    React.useEffect(() => {
        if (GTM_ID) {
            initGTM(GTM_ID);
            console.log('🏷️ GTM initialized with ID:', GTM_ID);
        } else {
            console.warn('⚠️ GTM_ID not found in environment variables');
        }
    }, []);

    return (
        <ErrorBoundary>
            <SEOHead />
            <Router> {/* 🆕 NEW: Wrap everything in Router */}
                {/* Enhanced Analytics Tracker with GTM + Backend + Geolocation */}
                <Tracker
                    enableGeolocation={true}     // Use GPS + IP location tracking
                    enableGTM={!!GTM_ID}         // Enable GTM if ID is provided
                    trackMouseMove={false}       // Disabled for better performance
                    throttleDelay={1000}         // 1 second throttle for scroll events
                />
                {/* Development Debug Panel - uncomment when testing */}
                {/* {process.env.NODE_ENV === 'development' && <AnalyticsDebug />} */}

                <div>
                    {/* 🆕 NEW: Route-based rendering */}
                    <Routes>
                        {/* Main landing page */}
                        <Route path="/" element={<LandingPage />} />

                        {/* 🆕 NEW: Email verification page */}
                        <Route path="/verify-email" element={<EmailVerification />} />

                        {/* 🆕 NEW: Catch-all route - redirect to home */}
                        <Route path="*" element={<LandingPage />} />
                    </Routes>

                    {/* Toast notifications */}
                    <Toaster
                        position="top-center"
                        toastOptions={{
                            duration: 4000,
                            style: {
                                background: '#2a2a2a',
                                color: '#fff',
                                border: '1px solid #FFE135'
                            },
                            success: {
                                iconTheme: {
                                    primary: '#FFE135',
                                    secondary: '#2a2a2a',
                                },
                            },
                            // 🆕 NEW: Enhanced error styling for verification messages
                            error: {
                                duration: 5000,
                                iconTheme: {
                                    primary: '#ff4444',
                                    secondary: '#2a2a2a',
                                },
                            },
                        }}
                    />
                </div>
            </Router>
        </ErrorBoundary>
    );
}

export default App;